import React, { PropsWithChildren } from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';

import styles from './styles.module.scss';

type Props = {
  /**
   * Example:
   * linear-gradient(
   *  180deg,
   *  rgba(255, 255, 255, 0.7) 0%,
   *  rgba(255, 255, 255, 0.5) 77.6%,
   *  #f8f4f1 100%
   * ),
   * url('/images/background.png')
   */
  backgroundImageStyle: string;
} & BaseComponentProps;

const ImageBackground = (props: PropsWithChildren<Props>) => {
  const { children, containerStyle, backgroundImageStyle } = props;

  return (
    <div
      className={clsx([styles.imageBackground, containerStyle])}
      style={{ backgroundImage: backgroundImageStyle }}
    >
      {children}
    </div>
  );
};

export default ImageBackground;
